export default __webpack_public_path__ + "static/media/icn-three-dots.39b46d38.svg";